export default __webpack_public_path__ + "static/media/p21.67bb8663.jpg";